import React from 'react'
import { COLORES } from '../../../../../config/colores'

export const COLUMNS = [
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: false,
      filterType: 'checkbox',
      setCellProps: () => ({
        style: {
          position: 'sticky',
          left: '0',
          background: COLORES.grey.light,
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          position: 'sticky',
          left: 0,
          background: 'white',
          zIndex: 101
        }
      })
    }
  },
  {
    name: 'camionesConBruto',
    label: 'Pesados sin volcar',
    options: {
      filter: false,
      sort: false,
      total: true
    }
  },
  {
    name: 'netoConBruto',
    label: 'Neto con bruto',
    options: {
      filter: false,
      sort: false,
      total: true
    }
  },
  {
    name: 'camionesConVolcadoPv1',
    label: 'Volcado PV1',
    options: {
      filter: false,
      sort: false
    }
  },
  {
    name: 'camionesConVolcadoPv2',
    label: 'Volcado PV2',
    options: {
      filter: false,
      sort: false
    }
  },
  {
    name: 'camionesConVolcadoPv4',
    label: 'Volcado PV4',
    options: {
      filter: false,
      sort: false
    }
  },
  {
    name: 'camionesConVolcadoPv5',
    label: 'Volcado PV5',
    options: {
      filter: false,
      sort: false
    }
  },
  {
    name: 'camionesConVolcadoLineaa',
    label: 'Volcado Linea A',
    options: {
      filter: false,
      sort: false
    }
  },
  {
    name: 'camionesConVolcado',
    label: 'Volcados',
    options: {
      filter: false,
      sort: false,
      total: true
    }
  },
  {
    name: 'netoOrigenConVolcado',
    label: 'Neto volcado',
    options: {
      filter: false,
      sort: false,
      total: true,
      setCellProps: () => ({
        style: {
          background: COLORES.grey.dark,
          color: 'white',
          zIndex: 100
        }
      }),
      setCellHeaderProps: () => ({
        style: {
          whiteSpace: 'nowrap',
          background: 'white',
          zIndex: 101
        }
      }),
      customBodyRender: (neto) => {
        return <p style={{ fontWeight: 'bold' }}>{neto}</p>
      }
    }
  }
]
